import React from "react";

type Props = {
    targetId: string;
    label?: string;
};

/** WCAG 2.4.1: one keyboard step from the top of the page to the Daily content. */
export const SkipLink: React.FC<Props> = ({ targetId, label = "Saltar al contenido de Daily" }) => (
    <a className="skip-link daily-skip-link" href={`#${targetId}`}>{label}</a>
);
